import React, { Fragment, useContext } from "react";
import { StateContext, DispatchContext } from "bodycodi/cmap/app/components/common/context";

// common
import CustomDialog from "bodycodi/cmap/app/components/common/customDialog";
import PopupHeader from "bodycodi/cmap/app/components/common/popupHeader";

const SERVICE_TEXT = [
  {
    title: "제1조 (목적)",
    contents: [
      {
        num: "0",
        text: `본 약관(이하 "약관")은 ㈜레드블루(이하 “회사”)가 제공하는 바디코디 서비스(이하 “바디코디”)의 이용과 관련하여 “회사”와 “회원”에 관한 제반 사항을 규정함을 목적으로 합니다.`,
      },
    ],
  },
  {
    title: "제2조 (용어의 정의)",
    contents: [
      { num: "0", text: `본 약관에서 사용하는 용어의 의미는 다음과 같습니다.` },
      {
        num: "1",
        text: `“바디코디”는 “회사”가 “회원”에게 제공하는 업무 관련 제반 서비스를 말합니다.`,
      },
      {
        num: "2",
        text: `“회원”은 “바디코디”를 이용하기 위해 본 약관에 동의한 이용자를 말합니다.`,
      },
      {
        num: "3",
        text: `“아이디(ID)”는 회원의 식별과 “바디코디” 이용을 위한 문자와 숫자의 조합을 의미합니다.`,
      },
      {
        num: "4",
        text: `“비밀번호”는 “회원”이 설정한 “아이디”와 일치하는 “회원”임을 확인하고, 비밀 보호를 위해 회원 자신이 정한 문자와 숫자의 조합을 의미합니다.`,
      },
    ],
  },
  {
    title: "제3조 (약관의 게시 및 개정)",
    contents: [
      {
        num: "1",
        text: `“회사”는 이 약관의 내용을 “회원”이 쉽게 알 수 있도록 “바디코디” 홈페이지(이하 “서비스 홈페이지”)에 게시합니다.`,
      },
      {
        num: "2",
        text: `“회사”는 “약관의 규제에 관한 법률” 등 관련법을 위배하지 않는 범위 내에서 약관을 개정할 수 있습니다.`,
      },
      {
        num: "3",
        text: `“회사”가 약관을 개정할 경우에는 시행일 및 개정사유를 명시하여 “서비스 홈페이지”에 시행일 7일 전까지 공지합니다.`,
      },
      {
        num: "4",
        text: `제3항의 방법으로 변경 고지된 약관은 기존의 “회원”에게도 유효하게 적용됩니다.`,
      },
    ],
  },
  {
    title: "제4조 (약관의 해석 및 관할법원)",
    contents: [
      {
        num: "1",
        text: `약관에 정하지 아니한 사항과 이 약관의 해석에 관하여는 관계법령 및 상관례에 따릅니다.`,
      },
      {
        num: "2",
        text: `“회사”와 “회원” 간 분쟁이 발생할 경우에 관할 법원은 “서울중앙지방법원”으로 합니다.`,
      },
    ],
  },
  {
    title: "제5조 (회원가입 및 자격)",
    contents: [
      {
        num: "1",
        text: `이용 계약은 “회원”이 되고 자 하는 가입 신청자가 약관 내용에 대하여 동의한 후 회원가입신청을 하고,“회사”가 이러한 신청에 대하여 승낙함으로써 체결됩니다.`,
      },
      {
        num: "2",
        custom: true,
        text: [
          "“회사”는 가입 신청자의 신청에 대하여 이용을 승낙함을 원칙으로 합니다. 다만, “회사”는 다음 각호에 해당하는 신청에 대하여는 회원가입을 인정하지 않거나 서비스 이용을 제한, 영구금지, 회원자격 박탈 등의 조치를 할 수 있습니다.",
        ],
      },
      {
        num: "3",
        text: `제1항에 따른 신청에 있어 “회사”는 “회원”의 종류에 따라 본인인증을 요청할 수 있습니다.`,
      },
      {
        num: "4",
        text: `“회사”가 회원 자격을 박탈하는 경우에는 회원등록을 말소합니다. 이 경우 “회원”에게 사전 통지하여 소명할 기회를 부여합니다. 단, “회원”의 귀책사유로 통지할 수 없는 경우 통지를 생략할 수 있습니다.`,
      },
    ],
  },
  {
    title: "제6조 (회원 탈퇴)",
    contents: [
      {
        num: "1",
        text: `“회원”은 언제든지 탈퇴를 요청할 수 있으며, “회사”는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다. 단, 이용 중인 “바디코디”를 모두 해지한 이후에 탈퇴가 처리됩니다.`,
      },
      {
        num: "2",
        text: `“회사”는 ‘회원’이 서비스를 이용하지 않거나 로그인하지 않는 경우 정보통신망법 제29조에 따라 해당 계정의 개인정보를 삭제합니다.`,
      },
      {
        num: "3",
        text: `제2항에 의해 개인정보가 삭제된 경우, 해당 계정은 탈퇴 처리됩니다.`,
      },
    ],
  },
  {
    title: "제7조 (“회원”에 대한 통지)",
    contents: [
      {
        num: "1",
        text: `“회사”가 “회원”에 대한 통지를 하는 경우 “회원”이 “회사”에 제출한 전자우편 주소로 할 수 있습니다.`,
      },
      {
        num: "2",
        text: `“회사”는 불특정다수 “회원”에 대한 통지의 경우 1주일 이상 “서비스 홈페이지”에 게시함으로써 개별 통지에 갈음할 수 있습니다.`,
      },
    ],
  },
  {
    title: "제8조 (개인정보의 수집 및 개인정보취급방침)",
    contents: [
      {
        num: "1",
        text: `“회사”는 서비스를 제공하기 위하여 관련 법령의 규정에 따라 “회원”으로부터 필요한 개인정보를 수집합니다.`,
      },
      {
        num: "2",
        text: `“회사”의 “개인정보취급방침”은 “회사”와 이용계약을 체결한 “회원”에 한해 적용됩니다.`,
      },
    ],
  },
  {
    title: "제9조 (“회사”의 의무)",
    contents: [
      {
        num: "1",
        text: `“회사”는 본 약관이 정하는 바에 따라 지속적이고 안정적인 서비스를 제공하는 데 최선을 다합니다.`,
      },
      {
        num: "2",
        text: `“회사”는 수신 동의하지 않은 영리 목적의 광고성 전자우편, 문자메시지 등을 발송하지 않습니다.`,
      },
      {
        num: "3",
        text: `“회사”는 서비스로 인해 알게 된 “회원”의 개인정보를 본인의 승낙 없이 제삼자에게 누설, 배포하지 않고, 이를 보호하기 위해 노력합니다. 개인정보보호에 관한 기타의 사항은 정보통신망법 및 “회사”가 별도로 정한 “개인정보취급방침”에 따르며 이때 “회원”은 회원의 권리를 갖습니다.`,
      },
      {
        num: "4",
        text: `“회사”가 제삼자와 서비스 제공계약 등을 체결하여 “회원”에게 서비스를 제공하는 경우 개별서비스별로 “회원”에게 명시적인 동의를 받은 후 동의의 범위 내에서 회원의 개인정보를 제삼자와 공유하는 등 관련 법령을 준수합니다.`,
      },
    ],
  },
  {
    title: "제10조 (“회원”의 의무)",
    contents: [
      {
        num: "1",
        custom: true,
        text: [
          "“아이디”와 “비밀번호”에 관한 관리의 책임은 “회원”에게 있습니다.",
          "가. “회원”은 자신의 “아이디” 및 “비밀번호”를 제삼자가 부정한 목적으로 이용하게 하여서는 안 됩니다.",
          "나. “회원”이 “아이디” 또는 “비밀번호”를 도난당하거나 제삼자가 이를 사용하고 있음을 인지한 경우 즉시“회사”에 통보하여야 하고, “회사”의 안내가 있는 경우에는 그에 따라야 합니다.",
        ],
      },
      {
        num: "2",
        custom: true,
        text: [
          "“회원”은 다음 행위를 하여서는 안 됩니다.",
          "가. 타인의 정보도용",
          "나. “회사”가 게시한 정보의 변경",
          "다. “회사”가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시",
          "라. “회사”와 기타 제삼자의 저작권 등 지적 재산권에 대한 침해",
          "마. “회사” 및 기타 제삼자의 명예를 손상하거나 업무를 방해하는 행위",
          "바. 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위",
          "사. 기타 불법적이거나 부당한 행위",
        ],
      },
      {
        num: "3",
        text: `“회원”은 본 약관 및 관계 법령에서 규정한 사항을 준수합니다.`,
      },
      {
        num: "4",
        text: `“회원”은 “바디코디”를 이용하여 얻은 정보를 “회사”의 사전 승낙 없이 복사, 복제, 변경, 번역, 출판 및 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없습니다.`,
      },
    ],
  },
  {
    title: "제11조 (책임 제한)",
    contents: [
      {
        num: "1",
        custom: true,
        text: [
          "“회사”는 다음 각 호의 경우로 인하여 “회원”에게 발생한 손해에 대해서 책임을 면제합니다.",
          "가. 천재지변 또는 이에 준하는 불가항력의 상태가 있는 경우",
          "나. “회원”의 귀책사유로 “바디코디” 이용에 장애가 있는 경우",
          "다. “회사” 이외의 타 사업자가 제공하는 서비스의 장애로 인한 경우",
        ],
      },
      {
        num: "2",
        text: `“회사”는 “회원”이나 제삼자가 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여 책임을 지지 않습니다.`,
      },
      {
        num: "3",
        text: `“회사”는 무료로 제공하는 서비스와 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.`,
      },
      {
        num: "4",
        text: `본 약관의 적용은 이용계약을 체결한 “회원”에 한하며, 제삼자에 의한 어떠한 배상, 소송 등에 대하여 “회사”는 책임을 면합니다.`,
      },
    ],
  },
  {
    title: "[부칙]",
    contents: [
      {
        num: "0",
        text: `본 약관은 2017년 2월 1일부터 시행합니다.`,
      },
    ],
  },
];

const ServicePop = () => {
  const { state } = useContext(StateContext);
  const { dispatch } = useContext(DispatchContext);

  const handleClose = () => {
    dispatch({
      type: "POP_UP_OPEN",
      id: "SERVICE_DETAIL_POP",
      open: { serviceDetailPop: false },
    });
  };

  return (
    <CustomDialog open={state.serviceDetailPop} onClose={handleClose}>
      <PopupHeader title={"서비스 이용약관"} onClickBack={handleClose} />
      <div className="terms-body">
        {SERVICE_TEXT.map((v, index) => {
          return (
            <div className="term-wrapper" key={index}>
              <span className="term-title">{v.title}</span>
              {v.contents.map((c: any, index) => {
                return (
                  <div className="term-content" key={index}>
                    {c.num !== "0" && <span className="term-text number-point">{c.num}.</span>}
                    {c.custom ? (
                      <div>
                        {c.text.map((t: any, index: any) => (
                          <Fragment key={index}>
                            <span className="term-text">{t}</span>
                            <br />
                          </Fragment>
                        ))}
                      </div>
                    ) : (
                      <span className="term-text" key={index}>
                        {c.text}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    </CustomDialog>
  );
};

export default ServicePop;
